module.exports = __webpack_public_path__ + "static/media/satc.1479959a.png";